<div #track class="track">
  <div #filledTrack class="filled-track"></div>

  <div #startHandle class="start-handle"></div>

  <div #endHandle class="end-handle"></div>
</div>
